// Flex.tsx - Polymorphic Flexbox layout components
import React, { forwardRef } from "react";
import Box from "../Box/Box";
import { FlexBaseProps, FlexComponent } from "./Flex.types";

/**
 * Flex component - A polymorphic layout component with flex display
 *
 * @example
 * // Basic usage
 * <Flex direction="row" gap="medium">
 *   <Box>Item 1</Box>
 *   <Box>Item 2</Box>
 * </Flex>
 *
 * // As a nav element
 * <Flex as="nav" justify="space-between" align="center">
 *   <Box>Logo</Box>
 *   <Box>Menu</Box>
 * </Flex>
 */
export const Flex = forwardRef(function Flex(
  props: FlexBaseProps & { as?: React.ElementType },
  ref
) {
  const { inline = false, as, ...rest } = props;

  return (
    <Box
      ref={ref}
      as={as}
      display={inline ? "inline-flex" : "flex"}
      {...(rest as Record<string, unknown>)}
    />
  );
}) as FlexComponent;

// Set display name for debugging
Flex.displayName = "Flex";

export default Flex;
